<template>
	<!-- 股东结构 -->
	<div class="container">
		<CTabs v-model="activeTab" :option="tabOption" />
		<div class="act-content">
			<keep-alive>
				<template v-for="(id, index) in moduleList">
					<component v-if="activeTab === index" :key="index" :is="getComponent(id)" />
				</template>
			</keep-alive>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import CTabs from '@/view/enterprise/components/c-tabs.vue';
import ShareholderCount from './ShareholderCount.vue';
import InstitutionalHolding from './InstitutionalHolding.vue';
import TopTenShareholder from './TopTenShareholder.vue';
import i18n, { EN, ZH, ZH_HK } from '@/assets/js/i18n';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useCommonData } from '@rebuild/hooks/useCommonData';

// shareholder_count 股东人数
// institutional_holding 机构持股
// top_ten_shareholder 十大股东
const COMP_MAPS = {
	shareholder_count: ShareholderCount,
	institutional_holding: InstitutionalHolding,
	top_ten_shareholder: TopTenShareholder
};

const { isCardTmpl } = useCommonData();

const activeTab = ref(0);
const tabOption = ref([]);
const moduleList = ref([]);

function getComponent(id) {
	return COMP_MAPS[id];
}

const { trans_modules } = useModuleData();

onMounted(async () => {
	// 获取模块中英繁对照列表，映射 tab 名称
	await trans_modules.refresh();
	const resData = trans_modules.data?.data || [];

	const tabs = [{ id: 'shareholder_count' }, { id: 'institutional_holding' }, { id: 'top_ten_shareholder' }];
	const languageMap = {
		[EN]: 'enName',
		[ZH_HK]: 'chtName',
		[ZH]: 'name'
	};
	const fieldName = languageMap[i18n.locale];
	tabs.forEach(tab => {
		const matchingModule = resData?.find(module => module.moduleId === tab.id);
		if (matchingModule) {
			tab.name = matchingModule[fieldName];
		}
	});

	// 新版H5 或 英文环境下，过滤掉「机构持股」功能
	const isEn = i18n.locale === EN;
	if (isCardTmpl.value || isEn) {
		const excludeIndex = tabs.findIndex(v => v.id === 'institutional_holding');
		if (excludeIndex !== -1) tabs.splice(excludeIndex, 1);
	}

	// 按顺序生成 tabs 选项，并推入 ACTIVITY_RATE 以匹配组件映射
	tabOption.value = tabs.map(tab => {
		moduleList.value.push(tab.id);
		return tab.name;
	});
});
</script>

<style lang="less" scoped>
.container {
	height: 100%;
	display: flex;
	flex-direction: column;

	.act-content {
		flex: 1;
		height: 0;
		overflow-y: auto;
	}
}
</style>
